import { create } from 'zustand';
import { createDefaultFilterSlice, DefaultFilterState } from '../filters';
import { persist } from 'zustand/middleware';

type FiltersState = {};
export const useTalentsFilterStore = create<DefaultFilterState & FiltersState>()(
  persist(
    (set, ...a) => ({
      ...createDefaultFilterSlice(set, ...a),
    }),
    {
      name: 'userdata:providersListFilters',
    },
  ),
);
